import { NgApp } from '@hotjar/webapp/features/Angular/NgApp';
import { ErrorBoundaryRoute } from './ErrorBoundaryRoute';

import { NoAppInterfaceRoute } from './NoAppInterfaceRoute';
import { SiteAccessRequiredRoute } from './SiteAccessRequiredRoute';

export const NoInterfaceNgApp = (): JSX.Element => {
  return (
    <SiteAccessRequiredRoute>
      <NoAppInterfaceRoute>
        <ErrorBoundaryRoute squadSentryTag="hotjar" featureName="angularside">
          <NgApp />
        </ErrorBoundaryRoute>
      </NoAppInterfaceRoute>
    </SiteAccessRequiredRoute>
  );
};
